<script lang="ts">
  // Authority Register sub-panel per INTERFACE-SPECIFICATION.md §10.1.
  //
  // Live render of data/access-control.json joined with the
  // value-type-to-reviewer mapping from GOVERNANCE-ARCHITECTURE.md
  // §9.1. Two tables: by value type and by user.

  import { onMount } from 'svelte';
  import { accessControlState, loadAccessControlSnapshot } from '../../lib/access-control-store.svelte';

  onMount(() => {
    void loadAccessControlSnapshot();
  });

  const VALUE_TYPES = ['rates', 'fees', 'amounts', 'terms', 'purposes', 'methodology', 'schema', 'dimensions'] as const;

  function usersWithRole(role: string) {
    return accessControlState.users.filter((u) => u.roles.includes(role));
  }

  function userList(role: string): string {
    const users = usersWithRole(role);
    if (users.length === 0) return '—';
    return users.map((u) => u.display_name ?? u.email).join(', ');
  }
</script>

<section>
  {#if accessControlState.loading}
    <p class="muted">Loading…</p>
  {:else if accessControlState.error}
    <div class="banner banner-fail">{accessControlState.error}</div>
  {:else}
    <h3 class="section-heading">By value type</h3>
    <div class="table-scroll">
      <table class="cube-table">
        <thead>
          <tr>
            <th>Value type</th>
            <th>Proposer(s)</th>
            <th>Reviewer(s)</th>
          </tr>
        </thead>
        <tbody>
          {#each VALUE_TYPES as vt (vt)}
            <tr>
              <td>{vt}</td>
              <td>{userList(`proposer:${vt}`)}</td>
              <td>{userList(`reviewer:${vt}`)}</td>
            </tr>
          {/each}
        </tbody>
      </table>
    </div>

    <h3 class="section-heading" style="margin-top: var(--space-4)">By user</h3>
    <div class="table-scroll">
      <table class="cube-table">
        <thead>
          <tr>
            <th>Display name</th>
            <th>Email</th>
            <th>Roles</th>
            <th>Added</th>
          </tr>
        </thead>
        <tbody>
          {#each accessControlState.users as u (u.email)}
            <tr>
              <td>{u.display_name ?? u.email}</td>
              <td class="muted">{u.email}</td>
              <td class="muted"><code>{u.roles.join(' · ')}</code></td>
              <td class="muted">{u.added_at ?? '—'}</td>
            </tr>
          {/each}
        </tbody>
      </table>
    </div>
  {/if}
</section>

<style>
  code { font-family: var(--font-mono); font-size: 0.9em; }
</style>
